/**
 * Mobile Experience Carousel
 *
 * On mobile (≤ 749px), syncs the dot indicators with the
 * currently visible slide by listening to the scroll position
 * of the CSS scroll-snap track.
 *
 * No behaviour is applied on desktop — the stagger layout is
 * handled entirely with CSS.
 */

if (!customElements.get('mobile-experience-carousel')) {
  customElements.define(
    'mobile-experience-carousel',
    class MobileExperienceCarousel extends HTMLElement {
      connectedCallback() {
        this._grid = this.querySelector('.mobile-experience__grid');
        this._dots = this.querySelectorAll('.mobile-experience__dot');
        this._isMobile = window.innerWidth <= 749;

        this._onScroll = this._onScroll.bind(this);
        this._onResize = this._onResize.bind(this);

        if (this._isMobile) this._attach();

        window.addEventListener('resize', this._onResize, { passive: true });
      }

      disconnectedCallback() {
        this._detach();
        window.removeEventListener('resize', this._onResize);
      }

      _attach() {
        if (!this._grid) return;
        this._grid.addEventListener('scroll', this._onScroll, { passive: true });
      }

      _detach() {
        if (!this._grid) return;
        this._grid.removeEventListener('scroll', this._onScroll);
      }

      /**
       * Determine the active slide index from the scroll position
       * and update the matching dot.
       */
      _onScroll() {
        if (!this._grid || !this._dots.length) return;

        const { scrollLeft, scrollWidth } = this._grid;
        const slideWidth = scrollWidth / this._dots.length;
        const activeIndex = Math.round(scrollLeft / slideWidth);

        this._setActiveDot(activeIndex);
      }

      /**
       * Mark the dot at `index` as active, clear the rest.
       * @param {number} index
       */
      _setActiveDot(index) {
        this._dots.forEach((dot, i) => {
          dot.classList.toggle('mobile-experience__dot--active', i === index);
        });
      }

      /**
       * Reattach / detach listeners when crossing the mobile breakpoint.
       */
      _onResize() {
        const wasMobile = this._isMobile;
        this._isMobile = window.innerWidth <= 749;

        if (!wasMobile && this._isMobile) {
          this._attach();
        } else if (wasMobile && !this._isMobile) {
          this._detach();
        }
      }
    }
  );
}
